// extracted by mini-css-extract-plugin
export default {"appShell":"appLayout_appShell__9O8t1","header":"appLayout_header__Sn2YF","main":"appLayout_main__lr6ZG","navbar":"appLayout_navbar__hD-G+"};